// extracted by mini-css-extract-plugin
export default {"user-table":"User_user-table__o4nQw","user-table__action":"User_user-table__action__n09ta","user-table__action--button":"User_user-table__action--button__m1JFn"};